import apiUrl from '../../../constants';
import awsBucketName from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import {
  BasicSelect
} from 'vue-search-select'
import Paginate from 'vuejs-paginate'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { variables } from '../../../../config'
import { newAWB, RecReasonData } from '../../../services/getDataCall';
import { AWBNumberNormslization } from '../../../services/utility';
import { custom_sort } from '../../../services/utility';
import { SubReasonsList,sourceTypeList} from '../../../services/ntsActions';
import { checkForAssignee, assignDispute,bulkDisputeAccept,assignUserList } from '../../../services/disputeAssigneeCheck';
import { fetchClientList, disputeSubReason, fetchExternalDisputeReasons,getImgVidProofs } from '../../../services/externalDispute';
import { getNoOfDaysFromCurrentDate } from '../../../services/DateCalcFuntion';
export default {
  name: 'investigationactionbyoperation',
  components: {
    BasicSelect,
    Paginate,
    VueElementLoading,
    Multiselect
  },
  data() {
    return {
      newhubs: '',
      newhublist: [],
      show: false,
      show1: false,
      show2: false,
      //for hun list
      hub: '',
      hublist: [],
      //for status list
      Status: '',
      StatusList: [],
      //verification Status
      vStatus: '',
      vStatusList: [],
      myStr: '',
      todate: '',
      fromdate: '',
      manifestFromDate: '',
      manifestToDate: '',
      investigationStatus: '',
      investigationStatusOptions: [
        { id: 'open', label: 'Open' },
        { id: 'close', label: 'Close' }
      ],
      octroi_MRP: '',
      awbnumber: '',

      accesszonelist: '',
      parsedata: '',
      //shortage Type
      Shortagetypelist: [],
      Shortage_type: '',
      isLoading1: false,
      pageno: 0,
      pagecount: 1,
      listUserData: [],
      totalRows: '',
      //table
      tablehublist: [],
      currenthubname: '',
      originhubname: '',
      finaldestinationname: '',
      shortagetype: '',
      SubReasons:'',
      sourcetype:'',
      SubReasonsListData:[],
      sourcetypeListData:[],
      hubdroplist: [],
      editshowtable: false,
      operator: '',
      operatorOptions: [
        { id: '1', label: '>' },
        { id: '2', label: '<' },
        { id: '3', label: '=' }
      ],
      exportdis: '',
      shortagetype: '',
      List: [],
      abc: '',
      primaryKey: '',
      imgdata: '',
      showModal: false,
      shipmentTypeList: [{id:'DTO', label: 'DTO Shipment'}, {id:'RTO', label:'RTO Shipment'}],
      disputeStatusList: [],
      disputeStatus: '',
      clientList: [],
      client: '',
      clientMap: {},
      shipmentType: '',
      WHHandover: false,
      disputeReasonList: [],
      disputeReason: '',
      daysOperator: '',
      daysOperatorOptions: [
        { id: '1', label: '>' },
        { id: '2', label: '<' },
        { id: '3', label: '=' }
      ],
      numberOfDays: '',
      assigneeList: [],
      currentUserid:0,
      assignee: '',
      imgData: '',
      ListData: [],
      errormsg: '',
      shortagetype: '',
      totalcount: 0,
      shortagetypes: [{
        id: 'BagShortage',
        label: 'BagShortage'
      }, {
        id: 'Shortage',
        label: 'Shortage'
      }],
      pageValue: 0,
      verification:[],
      recreasons:[],
      Awb:[],
      RECReasonMap: {},
      link:`https://${awsBucketName.awsBucketName}.s3.ap-southeast-1.amazonaws.com/`,
      assignUserList:[],
      showBulk:false,
      bulkAWB: [],
      sortingDate:'',
      sortColumn: null,
      sortDirection: null,
      pendingday: '',
      STDassets : [],
      showSTDModal : false
    }
  },
  mounted() {
    var userToken = window.localStorage.getItem('accessuserToken');
    this.myStr = userToken.replace(/"/g, '');
    this.accesszonelist = window.localStorage.getItem('accesszone');
    this.parsedata = JSON.parse(this.accesszonelist);
    this.getzonehubs();
    this.status();
    this.shortageType();
    this.verificationStatusName();
    this.recReasonFetchData();
    this.fetchClient();
    this.fetchAssignUserList();
    this.SubReasonsListData=SubReasonsList()
    this.sourcetypeListData=sourceTypeList()
    this.pageno = 0;
    this.currentUserid = JSON.parse(window.localStorage.getItem('userinfo')).userid;
    if(localStorage.getItem('securitypageData') !== null){
      let pageNum = localStorage.getItem('pageNum');
      let input = JSON.parse(localStorage.getItem('securitypageData'));
      localStorage.removeItem('securitypageData');
      if(input === undefined) { input =''; }
      this.getPaginationData(pageNum?pageNum:1, input)
      localStorage.removeItem('pageNum')
    }
    this.sortColumn = null;
    this.sortDirection = null;
  },
  destroyed() {
    localStorage.removeItem('securitypageData');
  },
  computed: {
    checkDisabled: function () {
      const selectedOperator = this.operator && this.operator.id ? this.operator.id : this.operator;
      return selectedOperator === '' || selectedOperator === null || selectedOperator === undefined;
    },
    checkDisabledDays: function () {
      const selectedDaysOperator = this.daysOperator && this.daysOperator.id ? this.daysOperator.id : this.daysOperator;
      return selectedDaysOperator === '' || selectedDaysOperator === null || selectedDaysOperator === undefined;
    },
    ExportDisableds: function () {
      return (this.exportdis == '') ? true : false;
    },
    ShortageDisableds: function () {
      return (this.Status.label == 'Shortage') ? false : true;
    },
    ShowNtsSearchFeild: function () {
      return (this.Status.label == 'NTS') ? true : false;
    },
    sortedList() {
      if (!this.sortColumn) return this.listUserData;

      return [...this.listUserData].sort((a, b) => {
        const isAscending = this.sortDirection === "asc";

        const valueA =
          this.sortColumn === "netvalue" ? parseFloat(a[this.sortColumn]) : a[this.sortColumn];
        const valueB =
          this.sortColumn === "netvalue" ? parseFloat(b[this.sortColumn]) : b[this.sortColumn];

        if (valueA > valueB) {
          return isAscending ? 1 : -1;
        } else if (valueA < valueB) {
          return isAscending ? -1 : 1;
        }
        return 0;
      });
    },
  },
  methods: {
    toggle() {
      let checkboxes = document.getElementsByName("chk-shipment");
      let actionCheckbox = document.getElementsByName("actionToggle");
      for (var i = 0, n = checkboxes.length; i < n; i++) {
        if (actionCheckbox[0].checked) {
          if (!checkboxes[i].checked) {
            checkboxes[i].click();
          }
        } else {
          if (checkboxes[i].checked) {
            checkboxes[i].click();
          }
        }
      }
    },
    sortingEvent(event,sortValue){
      if(sortValue == 'Asc') {
        this.sortingDate=true
        this.searchData()
        return
      }
      this.sortingDate=false
      this.searchData()

    },
    fetchAssignUserList(){
      assignUserList({}, this.myStr).then(client => {
        let assignList = [...client.data.data, {"assigneeid" : null, "assingee" : "UnAssignList"}] 
        this.assignUserList = assignList.map(user => ({id: user.assigneeid, label: user.assingee}));      })
    },
    fetchDisputeReasons(shipmentType){
      console.log(shipmentType);
      let input = {
        taskType : shipmentType.id,
        disputeRaisedType : "Client"
      }
      fetchExternalDisputeReasons(input, this.myStr).then(reasons => {
        let resonData = reasons.data.ReturnResult;
        this.disputeReasonList = resonData.map((reasons, i) => ({id: i, label: reasons.reason}));
      });
    },
    fetchClient(){
      fetchClientList({}, this.myStr).then(client => {
        let clienList = client.data.data;
        this.clientList = clienList.map(client => ({id: client.ClientMasterID, label: client.CompanyName}));      })
    },
    getzonehubs() {
      this.show = true;
      axios({
        method: 'post',
        url: apiUrl.api_url + 'getZoneList',
        data: {},
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      }).then(result => {
        this.show = false;
        let finalHubData = []
        result.data.data.forEach((hub) => {
          finalHubData.push({
            id: hub.hubzoneid,
            label: hub.hubzonename
          })
        })
        this.newhublist = finalHubData
      },
        error => {
          this.show = false;
          console.error(error)
        })
    },
    callHub(newhublist) {
      this.hublist = []

      this.getHubList(newhublist.id)
      this.hub = ''
      if (newhublist.id != undefined) {
        this.getHubList()
      }
    },

    callVstatusList(StatusList) {
      this.vStatusList = []
      this.WHHandover = false; 
      this.showBulk=false
      if (['WHHandover', 'FWD Dispute'].includes(StatusList.label)) {
        this.WHHandover = this.showBulk = true;
    }      this.verificationStatus(StatusList.id);
      this.vStatus = ''
      if (StatusList.id != undefined) {
        this.verificationStatus()
      }


    },

    verificationStatus(id) {
      this.input = ({
        investigateshipmentstatusmasterid: id,
        investigationbuckettypeid: 3
      })

      if (id == undefined) {
        this.vStatusList = []
      } else {

        axios({
          method: 'post',
          url: apiUrl.api_url + 'verificationstatus',
          data: this.input,
          headers: {
            'Authorization': 'Bearer ' + this.myStr
          }
        }).then(result => {
          let vstatusdata = []
          result.data.data.forEach((x) => {
            vstatusdata.push({
              id: x.investigationactionmasterid,
              label: x.actionname
            })
          })
          this.vStatusList = vstatusdata
        },
          error => {

            console.error(error)
          })
      }
    },
    verificationStatusName() {
      axios({
        method: 'post',
        url: apiUrl.api_url + 'allVerificationStatus',
        data: this.input,
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      }).then(result => {
        let vstatusdata = []
        result.data.data.forEach((x) => {
          vstatusdata.push({
            id: x.investigationactionmasterid,
            label: x.actionname
          })
        })
        this.verification = vstatusdata
      },
        error => {

          console.error(error)
        })

    },
    status() {
      axios({
        method: 'post',
        url: apiUrl.api_url + 'status',
        data: {},
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      }).then(result => {

        let statusdata = []
        result.data.data.forEach((status) => {
          statusdata.push({
            id: status.statuscode,
            label: status.statusname
          })
        })
        this.StatusList = statusdata
      },
        error => {

          console.error(error)
        })
    },
    async ImageView(awb1, status) {
      this.errormsg = ''
      this.abc = awb1;
      let path = '';
      this.primaryKey = 123;
      // console.log(awb1, primary, status);
      // if (status === 17 || status === 13) {
      //   path = `${awsBucketName}/STD/${awb1}`;
      // } else {
      //   path = `${awsBucketName}/${this.primaryKey}${awb1}`;
      // }
      path = `STD/${awb1}`;
      this.input = ({
        key: path,
      });

      if (status == 1 || status == 20) {
        let input = {
          awb : awb1,
          status : status
        }
        const response = await getImgVidProofs(input,this.myStr)
          if (response.data.statusCode !== 100) {
            this.$alertify.error(response.data.msg)
            return;
          }
          const videoExtensions = ['mp4', 'mov', 'avi', 'mkv', 'flv', 'wmv', 'webm'];

          this.STDassets = response.data.data.reduce((acc, item) => {
            let fileExtension = item.key.split('.').pop().toLowerCase();

            if (videoExtensions.includes(fileExtension)) {
              acc.videourl.push({ UnboxingVideoProof1: item.url });
            } else {
              acc.clientImages.push({ attachment: item.url });
            }

            return acc;
          }, { clientImages: [], videourl: [] });
          this.showSTDModal = true;
      }
      else {
        axios({
          method: 'post',
          url: `${apiUrl.api_url
            }getListObjectFroms3`,
          data: this.input,
          headers: {
            Authorization: `Bearer ${this.myStr}`,
          },
        }).then((result) => {
          const images = result.data.data.Contents.sort(custom_sort);
          this.List = images.slice(0, 3);
          if (this.List.length <= 0) {
            this.errormsg = "No Image Found"
          }
        });
      }
    },

    downloadImage(filePath) {
      // console.log(filePath);
      this.show1 = true;
      this.input = ({
        key: filePath,
        fileName: 'download.png',
      });

      axios({
        method: 'post',
        url: `${apiUrl.api_url}fetchImages3`,
        data: this.input,
        headers: {
          Authorization: `Bearer ${this.myStr}`,
        },
      }).then((result) => {
        this.show1 = false;
        //console.log('result from fetch api', result);
        const finalImage = result.data.ImageData.Body.data;
        let buff = new Buffer.from(finalImage);
        let base64data = buff.toString('base64');
        this.imgData = 'data:image/png;base64,' + base64data
        // console.log('finalImage: ', toBase64(finalImage));
      });


      this.showModal = true;
    },

    closeImage() {
      this.showModal = false;
    },


    getHubList(id) {


      let finalhublist = []
      for (let i = 0; i < this.parsedata.hubaccess.length; i++) {
        if (id == this.parsedata.hubaccess[i]["HubZoneId"]) {

          finalhublist.push({
            id: this.parsedata.hubaccess[i]["HubID"],
            label: this.parsedata.hubaccess[i]["HubName"]
          })
          this.hublist = finalhublist;

        }
      }


    },
    resetForm() {
      this.pageValue = 0

      this.Status = this.vStatus = this.exportdis = this.hub = this.newhubs = this.octroi_MRP = this.todate = this.fromdate = this.manifestFromDate = this.manifestToDate = this.investigationStatus = this.awbnumber = this.Shortage_type = ''; this.isLoading = false;
      this.WHHandover = false;
      this.disputeStatus = '';
      this.numberOfDays = '';
      this.disputeReason = '';
      this.client = '';
      this.shipmentType = '';
      this.$validator.reset(); this.errors.clear();
      this.isLoading1 = false;
      this.listUserData = []; this.pageno = 0; this.totalcount = ''; this.pagecount = 1; this.totalRows = '';
      this.sortColumn = null;
      this.sortDirection = null;
    },
    shortageType() {
      axios({
        method: 'post',
        url: apiUrl.api_url + 'shortageType',
        data: {},
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      }).then(result => {

        let Shortagetype = []
        result.data.data.forEach((status) => {
          Shortagetype.push({
            id: status.statuscode,
            label: status.statusname
          })
        })
        this.Shortagetypelist = Shortagetype
      },
        error => {
          console.error(error)
        })
    },
    searchUserData() {
      this.pageno = 0;
      this.$refs.paginate.selected = 0;
      this.searchData();
    },
    //to get pagination
    getPaginationData(pageNum, input='') {
      localStorage.setItem('pageNum', pageNum)
      this.pageValue = pageNum -1;
      this.pageno = (pageNum - 1) * variables.pageRecordLimit
      this.searchData(this.pageno, input)
    },

    getregionname() {
      this.editshowtable = false;
      for (let j = 0; j < this.listUserData.length; j++) {

        for (let i = 0; i < this.newhublist.length; i++) {
          if (this.listUserData[j]["hubzoneid"] !== null && this.listUserData[j]["hubzoneid"] != undefined) {

            if (this.newhublist[i]["id"] == this.listUserData[j]["hubzoneid"]) {
              this.listUserData[j]["regionname"] = this.newhublist[i]["label"];

            }
          }
        }

      }

      this.editshowtable = true;
    },
    Statusname() {
      axios({
        method: 'post',
        url: apiUrl.api_url + 'statusforstatusnames',
        data: {},
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }

      }).then(result => {
        this.StatusList2 = result.data.data;
        this.editshowtable = false;

        for (let j = 0; j < this.listUserData.length; j++) {

          for (let i = 0; i < this.StatusList2.length; i++) {
            if (this.listUserData[j]["status"] !== null && this.listUserData[j]["status"] != undefined) {

              if (this.StatusList2[i]["statuscode"] == this.listUserData[j]["status"]) {
                this.listUserData[j]["Statusname"] = this.StatusList2[i]["statusname"];

              }
            }
          }

        }

        this.editshowtable = true;

      },
        error => {
          this.show = false;
          console.error(error)
        })
    },
    verificationStatusList() {
      this.editshowtable = false;
      for (let j = 0; j < this.listUserData.length; j++) {

        for (let i = 0; i < this.verification.length; i++) {
          if (this.listUserData[j]["actionstatuscode"] !== null && this.listUserData[j]["actionstatuscode"] != undefined) {

            if (this.verification[i]["id"] == this.listUserData[j]["actionstatuscode"]) {
              this.listUserData[j]["VerificationStatus"] = this.verification[i]["label"];
            }
          }
        }

      }

      this.editshowtable = true;
    },
    NewAwb(data) {
      newAWB(data, this.myStr).then(result => {
        result.data.data.forEach((status) => {
          this.listUserData.forEach((data, i) => {
            if(data.shippingid === status.shippingid){
              this.listUserData[i]["newAWB"] = status.shippingid + 'REC';
              this.listUserData[i]["recreasionname"] = this.Recreasion(status.recreasonid)
            }
          });
        });
      });
    },
    getClientList() {

      axios({
        method: 'post',
        url: `${apiUrl.api_url}getClientList`,
        data: {},
        headers: {
          'Authorization': `Bearer ${this.myStr}`
        }

      }).then(result => {
        this.clienList = result.data.data;

        this.editshowtable = false;

        for (let j = 0; j < this.listUserData.length; j++) {

          for (let i = 0; i < this.clienList.length; i++) {
            if (this.listUserData[j]["clientid"] !== null && this.listUserData[j]["clientid"] != undefined) {

              if (this.clienList[i]["ClientMasterID"] == this.listUserData[j]["clientid"]) {
                this.listUserData[j]["Clientname"] = this.clienList[i]["CompanyName"];

              }
            }
          }

        }

        this.editshowtable = true;

      },
        error => {
          this.show = false;
          console.error(error)
        })
    },
    Recreasion(data) {
      let RecReason;
      if(data !== null && data !== undefined){
        RecReason = this.RECReasonMap[data]
      }
      return RecReason;
    },

    recReasonFetchData(){
      RecReasonData(this.myStr).then(result => {
        this.recreasons= result.data.data;
        this.recreasons.map((reasons) => {
          this.RECReasonMap[reasons.recreasonsid] = reasons.recreason
        });
      },
        error => {
          this.show = false;
          console.error(error)
        })
    },
    //searchbutton
    searchData(pageNo,input='') {
      this.sortColumn = null;
      this.sortDirection = null;
      this.awbnumber = AWBNumberNormslization(this.awbnumber).toString();
      this.isLoading1 = true
      this.show2 = true
      this.listUserData = []; this.totalcount = ''; this.pagecount = 1; this.totalRows = '';
      this.exportdis = 1;
      this.totalcount = 0
      const stopSearch = (message) => {
        this.isLoading1 = false;
        this.show2 = false;
        this.$alertify.error(message);
      };
      var formats= /[`!@#$%^&*()_+\-=\[\]{};':"\\|.<>\/?~]/
      if(this.awbnumber) this.showBulk=true
      if(formats.test(this.awbnumber))
      {
        stopSearch("Please Search Comma Seprated Shippingids")

      }
      else if (!this.awbnumber && (!this.newhubs || !this.newhubs.id)) {
        stopSearch("Please Select Hub Zone First")
      }
      else{  
      if (this.vStatus.id) {
        var vid = this.vStatus.id;
        var vstatusid = vid.toString();
      }
      if ((this.fromdate && !this.todate) || (!this.fromdate && this.todate)) {
        stopSearch("Please enter both  date")

      }
      else if (this.fromdate > this.todate) {
        stopSearch("From date should not be greater than To date")

      }
      else if ((this.manifestFromDate && !this.manifestToDate) || (!this.manifestFromDate && this.manifestToDate)) {
        stopSearch("Please enter both shipment manifest dates")
      }
      else if (this.manifestFromDate > this.manifestToDate) {
        stopSearch("Shipment manifest from date should not be greater than to date")
      }
      else if ((this.fromdate && this.todate) || (!this.fromdate && !this.todate)) {

        this.input = ({
          offset: pageNo,
          limit: variables.pageRecordLimit,
          shippingid: this.awbnumber,
          FromDate: this.fromdate,
          ToDate: this.todate,
          status: this.Status.id,
          actionstatuscode: vstatusid,
          hubzoneid: this.newhubs && this.newhubs.id ? this.newhubs.id : undefined,
          currenthubid: this.hub && this.hub.id ? this.hub.id : undefined,
          //originhubid: this.hub.id,
          operator: this.operator && this.operator.id ? this.operator.id : this.operator,
          netvalue: this.octroi_MRP,
          shortagetype: this.shortagetype && this.shortagetype.id ? this.shortagetype.id : undefined,
          sourcetype: this.sourcetype && this.sourcetype.label ? this.sourcetype.label : undefined,
          subreasons: this.SubReasons && this.SubReasons.label ? this.SubReasons.label : undefined,
          sortingDate:this.sortingDate

        });
        if (this.manifestFromDate && this.manifestToDate) {
          this.input.frommanifesteddate = `${this.manifestFromDate.slice(0, 10)} 00:00:00`;
          this.input.tomanifesteddate = `${this.manifestToDate.slice(0, 10)} 23:59:59`;
        }
        const selectedInvestigationStatus =
          this.investigationStatus && this.investigationStatus.id
            ? this.investigationStatus.id
            : this.investigationStatus;
        if (selectedInvestigationStatus) {
          this.input.investigationstatus = selectedInvestigationStatus === 'open';
        }
        if(this.disputeStatus && this.disputeStatus != '') this.input.actionstatuscode = this.disputeStatus.id.toString();
        if(this.disputeReason && this.disputeReason != '') this.input.disputeReason = this.disputeReason.label.toString();

        if(this.client && this.client.length > 0){
          let clientArray = this.client.map(clients => clients.id);
          this.input.client = clientArray;
        }
        if(this.assignee && this.assignee != '') this.input.assignee = this.assignee.label;
        
        if(this.shipmentType && this.shipmentType != '') this.input.shipmentType = this.shipmentType.id;
        const selectedDaysOperator = this.daysOperator && this.daysOperator.id ? this.daysOperator.id : this.daysOperator;
        if(selectedDaysOperator && this.numberOfDays && this.numberOfDays != ''){
          this.input.daysOperator = selectedDaysOperator;
          this.input.numberOfDays = this.numberOfDays;
        }

        this.defaultSearch = Object.assign({}, input ? input : this.input);
        if(input === ''){
        localStorage.setItem('securitypageData', JSON.stringify(this.input))
        }
        
        axios({
          method: 'post',
          url: apiUrl.api_url + 'searchActionBySecurity',
          data: input? input : this.input,
          headers: {
            'Authorization': 'Bearer ' + this.myStr
          }
        }).then(async result => {
          this.show2 = false
          this.listUserData = Array.isArray(result.data.data) ? result.data.data : [];
          if (!this.listUserData.length) {
            this.isLoading1 = false;
            this.$alertify.error('No records found for the selected search filters');
          }
          for(var i = 0; i< this.listUserData.length; i++){

            if([20,1,12,11,19,13,15,16,17,14,18,21,22,23].includes(this.listUserData[i].status)){
              if([null, '28', '34', '25', '12','31', '32', '33', '34', '35'].includes(this.listUserData[i].actionstatuscode)){
              this.listUserData[i].editable = true;
            }
            }else{
              this.listUserData[i].editable = false;
            }
            if ([20, 22].includes(this.listUserData[i].status)) {
              let assigneeData = await this.disputeAssigneeCheck(this.listUserData[i].shippingid);
              this.listUserData[i].assigneeData = assigneeData;
            }
          }
          
          this.totalcount = typeof result.data.count === 'number' ? result.data.count : this.listUserData.length

          if (this.totalcount == undefined) {
            this.totalcount = this.listUserData.length
          }
          this.NewAwb(this.listUserData);
          this.gethubdropdown();
          this.getClientList();
          this.getregionname();
          this.Statusname();
          this.pendingDays();
          this.buckettypecode();
          this.verificationStatusList()
          this.Recreasion()
          this.getDisputeStatusName(result.data.data)
          if (this.totalcount < variables.pageRecordLimit) {
            this.pagecount = 1
          } else {
            this.pagecount = Math.ceil(this.totalcount / variables.pageRecordLimit)
          }
        }).catch(error => {
          this.isLoading1 = false;
          this.show2 = false;
          console.error(error);
          this.$alertify.error('Failed to fetch data');
        })
      }//else
    }//else
    },
    async getDisputeStatusName(data){
      let i = 0;
      for(let d of data){
        if(d.disputestatuscode !== null && d.disputestatuscode !== undefined && d.disputestatuscode !== '' &&
           d.status !== null && d.status !== undefined && d.status !== ''){
          this.input = ({
            Status: d.status,
            DisputeStatusCode: d.disputestatuscode
          });
          let result = await this.getDisputeStatusNameAPICall(this.input);
          this.listUserData[i].disputstatusname = result
        }else{
          this.listUserData[i].disputstatusname = '-'
        }
        i++;
      }
    },

    getDisputeStatusNameAPICall(input){
      return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url: apiUrl.api_url + 'DisputeSubStatus',
          data: input,
          headers: {
            'Authorization': 'Bearer ' + this.myStr
          }
        }).then(result => {
          return resolve(result.data.data[0]?result.data.data[0].pickupstatusname: '-');
        }).catch(err => {
          return reject (err);
        })
      })
    },
    //dropdown hub
    gethubdropdown() {
      axios({
        method: 'post',
        url: apiUrl.api_url + 'getHubdropdownlist',
        data: {},
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      }).then(result => {
        let finalHubData = []
        result.data.data.forEach((hub) => {
          finalHubData.push({
            id: hub.HubID,
            label: hub.HubName
          })
        })
        this.hubdroplist = finalHubData;
        this.editshowtable = false;

        for (let i = 0; i < this.hubdroplist.length; i++) {
          for (let j = 0; j < this.listUserData.length; j++) {
            if (this.listUserData[j]["currenthubid"] !== null && this.listUserData[j]["currenthubid"] != undefined) {

              if (this.hubdroplist[i]["id"] == this.listUserData[j]["currenthubid"]) {
                this.listUserData[j]["currenthubname"] = this.hubdroplist[i]["label"];
              }
            }
          }
        }

        for (let i = 0; i < this.hubdroplist.length; i++) {
          for (let j = 0; j < this.listUserData.length; j++) {
            if (this.listUserData[j]["originhubid"] !== null && this.listUserData[j]["originhubid"] != undefined) {

              if (this.hubdroplist[i]["id"] == this.listUserData[j]["originhubid"]) {
                this.listUserData[j]["originhubname"] = this.hubdroplist[i]["label"];
              }
            }
          }
        }
        for (let i = 0; i < this.hubdroplist.length; i++) {
          for (let j = 0; j < this.listUserData.length; j++) {
            if (this.listUserData[j]["finaldestinationid"] !== null && this.listUserData[j]["finaldestinationid"] != undefined) {

              if (this.hubdroplist[i]["id"] == this.listUserData[j]["finaldestinationid"]) {
                this.listUserData[j]["finaldestinationname"] = this.hubdroplist[i]["label"];
              }
            }
          }
        }
        for (let i = 0; i < this.hubdroplist.length; i++) {
          for (let j = 0; j < this.listUserData.length; j++) {
            if (this.listUserData[j]["disputemarkedonhub"] !== null && this.listUserData[j]["disputemarkedonhub"] != undefined) {

              if (this.hubdroplist[i]["id"] == this.listUserData[j]["disputemarkedonhub"]) {
                this.listUserData[j]["disputemarkedonhubname"] = this.hubdroplist[i]["label"];
              }
            }
          }
        }

        this.editshowtable = true;

      },
        error => {
          console.error(error)
        })
    },
    buckettypecode() {

      axios({
        method: 'post',
        url: apiUrl.api_url + 'getinvestigationbuckettype',
        data: {},
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }

      }).then(result => {
        this.ListData = result.data.data;

        this.editshowtable = false;

        for (let j = 0; j < this.listUserData.length; j++) {

          for (let i = 0; i < this.ListData.length; i++) {
            if (this.listUserData[j]["buckettypecode"] !== null && this.listUserData[j]["buckettypecode"] != undefined) {

              if (this.ListData[i]["investigatbuckettypeid"] == this.listUserData[j]["buckettypecode"]) {
                this.listUserData[j]["Buckettypename"] = this.ListData[i]["buckettypename"];

              }
            }
          }

        }

        this.editshowtable = true;

      },
        error => {
          this.show = false;
          console.error(error)
        })
    },
    exportfileCSV() {
      const exportPayload = Object.assign({}, this.defaultSearch || this.input || {});
      delete exportPayload.offset;
      delete exportPayload.limit;
      exportPayload.exportdata = true;

      if (!Object.keys(exportPayload).length) {
        this.$alertify.error('Please search data first');
        return;
      }

      this.show2 = true;
      axios({
        method: 'post',
        url: apiUrl.api_url + 'searchActionBySecurity',
        data: exportPayload,
        responseType: 'arraybuffer',
        headers: {
          'Authorization': 'Bearer ' + this.myStr,
          'Content-type': 'application/json'
        }
      }).then((response) => {
        this.show2 = false;

        if (!response.data || response.data.byteLength === 0) {
          this.$alertify.error('No data Found');
          return;
        }

        this.downloadCSV(response.data, `investigationDefault${moment(new Date()).format("YYYY-MM-DD_HH-mm-ss")}.xlsx`);
      }, (error) => {
        this.show2 = false;
        console.error(error);
        this.$alertify.error('Failed to export data');
      });
    },
    async disputeAssigneeCheck(shippingid){
      let token = this.myStr;
      let {data} = await checkForAssignee(shippingid, token);
      if(data.code == 200){
          return {
            isAssigned: true,
            assigneeName: data.data[0].assingee,
            assigneeId: data.data[0].assingeeuserid
          }
      }
      return {
        isAssigned: false,
      }
    },

    acceptDispute(shippingid){
      if(shippingid.length<=0)swal("Please select the shipment", {icon: "warning"});
    else {
      swal({
        title: "Are you sure?",
        text: `you want to accept the dispute for ${shippingid.length} shipments ?`,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
      .then((willDelete) => {
        if (willDelete) {
          swal("Shipments are marked as dispute", {icon: "success"});
          shippingid.forEach(async(ele) => {
          let input = {
            shippingid : ele.shippingid,
            username : window.localStorage.getItem('username'),
            actionstatuscode : '29' //Dispute Accepted by Executive
          }
          let {data} = await bulkDisputeAccept(input, this.myStr)
          if(data.ReturnCode == 100){
            //this.$alertify.success(data.ReturnMessage);
            this.searchData(this.pageNo, this.defaultSearch);
          }
        })
        }
      });
    }
    },

    assignMe(shippingid, i){
      console.log(i);
      let data ={
        "shippingid" : shippingid,
        "userid" : this.currentUserid,
        "username" : window.localStorage.getItem('username')
      }
      assignDispute(data, this.myStr).then(async res =>{
        if(res.data.ReturnCode == 100){
          let {data} = await checkForAssignee(shippingid, this.myStr);
          if(data.code == 200){
            this.listUserData[i].assigneeData = {
                                                isAssigned: true,
                                                assigneeName: data.data[0].assingee,
                                                assigneeId: data.data[0].assingeeuserid
                                              }
            this.searchData(this.pageNo, this.defaultSearch);

          }
        }
      })
    },

    downloadCSV(fileData, filename) {
      const blob = new Blob([fileData], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", filename || "investigationDefault.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    convertArrayOfObjectsToCSV: function (args) {
      var result, ctr, keys, columnDelimiter, lineDelimiter, data;
      data = args.data || null;
      if (data == null || !data.length) {
        return null;
      }
      //columnDelimiter = args.columnDelimiter || ",";
      lineDelimiter = args.lineDelimiter || "\n";
      //keys = Object.keys(data[0]).slice(0);
      columnDelimiter = "ShippingID,ClientName,OctrioMRP,hubzoneid,HubZoneName,CurrentHubName,OriginHubid,OriginHubName,DestinationHubName,DisputeSatusName,Requestfrom,CreatedBy,OrderType,PhysicalWeight,VolumetricWeight,LoggedDate,LoggedDescription,ColoaderName,BagCondition,Contents,StatusName,VerificationStatus,STDBagCondition,PendingDays,verifieddate,verifieddescription,approvaldate,approvaldescription,lastmodifiedby,ManifestInScanDate,shortagetype,bagno,recreasionname";
      result = "";
      result += columnDelimiter;
      result += lineDelimiter;
      for (let i = 0; i < data.length; i++) {
        result += (data[i].shippingid).toString()+ ',' + data[i].Clientname + ',' + data[i].netvalue + ',' + data[i].hubzoneid + ',' + data[i].hubzonename + ','  + data[i].currenthubname + ',' + data[i].originhubid + ',' + data[i].originhubname + ',' + data[i].finaldestinationname + ','  + data[i].disputstatusname + ',' + data[i].Buckettypename + ',' + data[i].createdby + ',' + data[i].ordertype + ',' +data[i].phyweight+ ',' + data[i].volweight + ',' +  moment(new Date(data[i].createddate)).format("DD/MM/YYYY") + ',' + data[i].loggeddescription + ',' + data[i].coloaderid + ',' + data[i].stdbagcondition + ',' + data[i].pendingdays + ',' + data[i].productinformation + ',' + data[i].Statusname + ',' + data[i].VerificationStatus + ',' + data[i].stdbagcondition + ','  + moment(new Date(data[i].verifieddate)).format("DD/MM/YYYY") + ',' + data[i].verifieddescription +',' + data[i].approvaldate + ',' + data[i].approvaldescription + ',' + data[i].lastmodifiedby +',' +  moment(new Date(data[i].createddate)).format("DD/MM/YYYY") +',' + data[i].shortagetype +',' + data[i].bagno +',' + data[i].recreasionname   ;

        result += lineDelimiter;


      }
      return result;
    },

    // new page
    neweditpage(awb, currenthubname, status, id,declaredvalue,previousshipmentstatus,actionstatuscode) {
      // localStorage.removeItem('securitypageData')
      console.log(status,"actionstatuscode");
      
      if(status == 1){
        this.$router.push({ path: '/EditProductDamage', query: {shippingid:awb,status:status,actionStatusCode:actionstatuscode} });
      }
      else this.$router.push({ path: '/EditSecurity', query: { awb: awb, currenthubname: currenthubname, status: status, id: id ,declaredvalue:declaredvalue, bucket: '3',previousshipmentstatus:previousshipmentstatus} });
    },
    sortTable(column, direction) {
      this.sortColumn = column;
      this.sortDirection = direction;
    },
    pendingDays() {
      this.editshowtable = false;
      for (let j = 0; j < this.listUserData.length; j++) {
        if (this.listUserData[j]["createddate"] !== null && this.listUserData[j]["createddate"] != undefined) {
          this.listUserData[j]["pendingdays"] = getNoOfDaysFromCurrentDate(moment(new Date(this.listUserData[j]["createddate"])).format("MM/DD/YYYY"))
        }

      }
      this.editshowtable = true;
    },
    closeSTDModal(){
      this.showSTDModal = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/PackagingDamageBySecurityTeam/PackagingDamageBySecurityTeam.component.js